export default __webpack_public_path__ + "static/media/CheckMark.b1254e0f.png";